<sui-dialog-header
  [class.root]="_currentPage === _Page.Main"
  (closeButtonClick)="_onCloseButtonClick()"
>
  <ng-container *ngIf="_currentPage === _Page.Main">도움말</ng-container>
  <div class="dialog-header" *ngIf="_currentPage !== _Page.Main">
    <button class="back-button" sui-icon-button (click)="_onBackButtonClick()">
      <sui-icon name="원형 이동_왼쪽"></sui-icon>
    </button>
    <!-- <div class="title">도움말 상세보기</div> -->
  </div>
</sui-dialog-header>
<div class="body" [class.is-hidden]="_currentPage !== _Page.Main">
  <div class="page main">
    <div class="title">
      <span class="text"
        >북이오 뷰어는 <br class="mobile" /><b>이렇게 사용해요 !</b></span
      >
    </div>
    <div class="lists">
      <div class="list">
        <div class="list-title">기본 설정</div>
        <div class="list-items">
          <ng-container *ngFor="let page of _pageListBasic">
            <ng-container
              *ngTemplateOutlet="listItem; context: { item: page }"
            ></ng-container>
          </ng-container>
        </div>
      </div>
      <!-- <div class="list">
        <div class="list-title">읽기 모드</div>
        <div class="list-items">
          <ng-container *ngFor="let page of _pageListReadingMode">
            <ng-container
              *ngTemplateOutlet="listItem; context: { item: page }"
            ></ng-container>
          </ng-container>
        </div>

        <div class="list-title">독서 기록</div>
        <div class="list-items">
          <ng-container *ngFor="let page of _pageListNotes">
            <ng-container
              *ngTemplateOutlet="listItem; context: { item: page }"
            ></ng-container>
          </ng-container>
        </div>
      </div> -->
      <div class="list no-icons">
        <div class="list-title">함께 읽기</div>
        <div class="list-items no-icons">
          <ng-container *ngFor="let page of _pageListNoteList">
            <ng-container
              *ngTemplateOutlet="listItem; context: { item: page }"
            ></ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
<div
  class="body no-main"
  [class.is-hidden]="_currentPage === _Page.Main"
  [ngSwitch]="_currentPage"
>
  <!-- 책 정보 보기 -->
  <div class="page" *ngSwitchCase="_Page.BookInfo">
    <div class="page-header">
      <sui-icon
        style="font-size: 30px"
        name="앱_도서 리스트"
        type="solid"
      ></sui-icon>
      <div class="title"><span>목차 보기</span></div>
    </div>
    <div class="ol">
      <div class="li">
        <div class="number">1.</div>
        <div class="text">책 제목과 저자를 확인할 수 있습니다.</div>
      </div>
      <div class="li">
        <div class="number">2.</div>
        <div class="text">
          '책 상세 보기' 버튼을 눌러 책 상세 페이지로 이동할
          <br class="desktop" />수 있습니다.
        </div>
      </div>
      <div class="li">
        <div class="number">3.</div>
        <div class="text">
          목차를 확인하고 해당 페이지로 이동할 수 있습니다.
        </div>
      </div>
      <div class="li" *ngIf="!_isApp">
        <div class="number">4.</div>
        <div class="text">
          부록이 있는 책이라면 부록 목록도 표시됩니다.
          <br class="desktop" />원하는 부록을 선택하여 바로 열람할 수 있습니다.
        </div>
      </div>
    </div>
  </div>
  <!-- 페이지 모아보기 -->
  <div class="page" *ngSwitchCase="_Page.Thumbnail">
    <div class="page-subheader">
      EPUB 도서는 페이지 모아 보기를 지원하지 않습니다.<br class="desktop" />
      전자책 파일 형식은 책 상세 페이지에서 확인하실 수 있습니다.
    </div>
    <div class="page-header">
      <sui-icon
        style="font-size: 30px"
        name="페이지 모아보기"
        type="solid"
      ></sui-icon>
      <div class="title"><span>페이지 모아보기</span></div>
    </div>
    <div class="ol">
      <div class="li">
        <div class="number">1.</div>
        <div class="text">
          PDF 도서의 전체 페이지를 한눈에 모아 볼 수 있습니다.
        </div>
      </div>
      <div class="li">
        <div class="number">2.</div>
        <div class="text">
          원하는 페이지를 선택하면 해당 페이지로 이동합니다.
        </div>
      </div>
    </div>
  </div>
  <!-- 설정 -->
  <div class="page settings" *ngSwitchCase="_Page.Settings">
    <div class="page-header">
      <sui-icon style="font-size: 30px" name="환경설정" type="solid"></sui-icon>
      <div class="title">
        <span>뷰어 설정</span>
      </div>
    </div>
    <div class="columns">
      <div class="column left">
        <div class="column-item">
          <div class="icon">
            <sui-icon name="테마" style="font-size: 30px"></sui-icon>
          </div>
          <div class="text">배경색 설정</div>
        </div>
        <div
          class="column-item"
          style="margin-top: 31px"
          *ngIf="_data.isPDFBook"
        >
          <div class="icon">
            <sui-icon
              name="두페이지 보기"
              style="font-size: 24px"
              type="solid"
            ></sui-icon>
          </div>
          <div class="text">
            두 페이지 보기<br /><span class="description"
              >한 화면에 두 페이지를 띄워 열람합니다. 단, 댓글창이 열려 있는
              경우 자동으로 한 페이지 보기 모드로 변경됩니다.</span
            >
          </div>
        </div>
        <div class="column-item" *ngIf="_data.isPDFBook">
          <div class="icon">
            <sui-icon
              name="페이지 넘김 효과"
              style="font-size: 24px"
              type="solid"
            ></sui-icon>
          </div>
          <div class="text">
            페이지 넘김 효과<br /><span class="description"
              >책장을 넘기듯 페이지를 부드럽게 전환합니다.</span
            >
          </div>
        </div>
        <div class="column-item" *ngIf="!_data.isPDFBook">
          <div class="icon">
            <sui-icon name="폰트" style="font-size: 30px"></sui-icon>
          </div>
          <div>글꼴 설정</div>
        </div>
        <div class="column-item" *ngIf="!_data.isPDFBook">
          <div class="icon">
            <sui-icon name="글자크기" style="font-size: 30px"></sui-icon>
          </div>
          <div>글자 크기 설정</div>
        </div>
        <div class="column-item" *ngIf="!_data.isPDFBook">
          <div class="icon">
            <sui-icon name="줄간격" style="font-size: 30px"></sui-icon>
          </div>
          <div>줄간격 설정</div>
        </div>
        <div class="column-item" *ngIf="!_data.isPDFBook">
          <div class="icon">
            <sui-icon name="좌우여백" style="font-size: 30px"></sui-icon>
          </div>
          <div>좌우 여백 설정</div>
        </div>
        <div class="column-item" *ngIf="!_data.isPDFBook">
          <div class="icon">
            <sui-icon name="문단간격" style="font-size: 30px"></sui-icon>
          </div>
          <div>문단 간격 설정</div>
        </div>

        <!-- 배율 고정 -->
        <div class="column-item" *ngIf="_data.isPDFBook">
          <div class="icon">
            <sui-icon name="확대" style="font-size: 30px"></sui-icon>
          </div>
          <div class="text">
            배율 고정 <br /><span class="description">
              페이지 전환시 확대/축소 배율이 고정됩니다. <br />
              (확대/축소 단축키: +/- )
            </span>
          </div>
        </div>
      </div>
      <div class="column right">
        <div class="column-item">
          <div class="icon">
            <sui-icon name="하이라이트" style="font-size: 24px"></sui-icon>
          </div>
          <div class="text">
            하이라이트 컬러 선택 (나의책보기)<br />
            <span class="description">
              최대 5개의 컬러를 선택할 수 있으며, 여기서 선택한 컬러들이 본문
              드래그 시 하이라이트 컬러 기본 옵션으로 제공됩니다.
            </span>
            <span class="highlight-description">
              <sui-icon name="도움말" type="solid"></sui-icon>
              <span> 그룹책보기에서는 밑줄 색상을 지정할 수 없습니다. </span>
            </span>
          </div>
        </div>
        <!-- <div class="column-item" *ngIf="!_data.isPDFBook">
          <div class="icon">
            <sui-icon
              name="스크롤"
              style="font-size: 24px"
              type="solid"
            ></sui-icon>
          </div>
          <div class="text">
            스크롤 보기<br /><span class="description"
              >좌우로 책장을 넘기는 방식을 상하 스크롤 방식으로
              변경합니다.</span
            >
          </div>
        </div> -->
        <div class="column-item" *ngIf="!_data.isPDFBook">
          <div class="icon">
            <sui-icon
              name="두페이지 보기"
              style="font-size: 24px"
              type="solid"
            ></sui-icon>
          </div>
          <div class="text">
            두 페이지 보기<br /><span class="description"
              >한 화면에 두 페이지를 띄워 열람합니다. 단, 댓글창이 열려 있는
              경우 자동으로 한 페이지 보기 모드로 변경됩니다.</span
            >
          </div>
        </div>
        <div class="column-item" *ngIf="!_data.isPDFBook">
          <div class="icon">
            <sui-icon
              name="페이지 넘김 효과"
              style="font-size: 24px"
              type="solid"
            ></sui-icon>
          </div>
          <div class="text">
            페이지 넘김 효과<br /><span class="description"
              >책장을 넘기듯 페이지를 부드럽게 전환합니다.</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- 필기 -->
  <div class="page drawing" *ngSwitchCase="_Page.Drawing">
    <div class="page-subheader mobile">
      필기 기능은 모바일 앱에서만 이용할 수 있습니다.
    </div>
    <div class="page-header">
      <sui-icon style="font-size: 30px" name="펜" type="solid"></sui-icon>
      <div class="title"><span>필기</span></div>
      <div class="subtitle desktop">
        필기 기능은 모바일 앱에서만 이용할 수 있습니다.
      </div>
    </div>
    <div class="columns drawing-guide">
      <div class="column">
        <div class="ol">
          <div class="li">
            <div class="number">1.</div>
            <div class="text">
              필기 기능은 '한 페이지 보기' 상태에서만 이용할 수 있습니다.
            </div>
          </div>
          <div class="li">
            <div class="number">2.</div>
            <div class="text">
              필기는 작성자 본인만 볼 수 있으며, 그룹책에는 공유되지 않습니다. 
            </div>
          </div>
          <div class="li">
            <div class="number">3.</div>
            <div class="text">
              앱에 남긴 필기는 웹에서도 볼 수 있습니다. 단, 기기를 변경하는
              경우에는 필기가 남아 있지 않으니 수동 백업/복원하기 기능을
              활용하세요. 
            </div>
          </div>
          <div class="li">
            <div class="number">4.</div>
            <div class="text">
              필기는 자동 백업됩니다. ‘설정 > 내 필기 기록 > 북이오 서버에 자동
              백업하기’를 OFF 상태로 변경할 수 있지만, 만약의 경우를 위해
              권장하지 않습니다. 
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="ol">
          <div class="li">
            <div class="number">5.</div>
            <div class="text tool-bar-guide">
              <sui-icon name="펜" type="solid"></sui-icon>펜 옵션은 4가지로
              설정할 수 있습니다. 펜 컬러와 투명도, 두께를 변경하여 사용하세요. 
            </div>
          </div>
          <div class="li">
            <div class="number">6.</div>
            <div class="text">
              <sui-icon name="텍스트필기" type="solid"></sui-icon> 버튼으로
              텍스트를 입력할 수 있습니다. 입력창 바깥 영역을 탭하면 입력 완료,
              텍스트를 한 번 더 탭하면 입력된 텍스트를 수정할 수 있습니다.
            </div>
          </div>
          <div class="li">
            <div class="number">7.</div>
            <div class="text tool-bar-guide">
              펜에<sui-icon name="자" type="solid"></sui-icon> 옵션을 추가하면
              해당 펜으로 긋는 선은 반듯한 직선으로 그려집니다.
            </div>
          </div>
          <div class="li">
            <div class="number">8.</div>
            <div class="text tool-bar-guide">
              터치 오류로 원치 않는 페이지 전환이 되는 것을 방지하기 위해 필기
              모드에서는
              <sui-icon name="페이지 앞으로" type="solid"></sui-icon>
              <sui-icon name="페이지 뒤로" type="solid"></sui-icon>
              버튼으로 페이지를 이동합니다. 
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- 북마크 -->
  <div class="page bookmark" *ngSwitchCase="_Page.Bookmark">
    <div class="page-header">
      <sui-icon style="font-size: 30px" name="북마크" type="solid"></sui-icon>
      <div class="title"><span>북마크</span></div>
    </div>
    <div class="ol">
      <div class="li">
        <div class="number">1.</div>
        <div class="text">
          화면 우측 상단의 북마크 버튼을 누르면 지금 보고 있는 페이지가<br
            class="desktop"
          />북마크 목록에 저장됩니다.
        </div>
      </div>
      <div class="li">
        <div class="number">2.</div>
        <div class="text">
          저장한 페이지는 화면 하단의 플로팅 버튼
          <div class="floating-button"><sui-icon name="플러스"></sui-icon></div>
          → 내 기록 전체 보기 <br class="desktop" />→ 북마크 탭에서 모아볼 수
          있습니다.
        </div>
      </div>
    </div>
  </div>
  <!-- 본문 검색 -->
  <div class="page" *ngSwitchCase="_Page.Search">
    <!-- <div class="page-subheader">
      검색 결과가 나오지 않는다면 구두점을 포함한<br class="desktop" />
      모든 문자가 정확하게 입력되었는지 확인해 주세요.
    </div> -->
    <div class="page-header">
      <sui-icon style="font-size: 30px" name="검색"></sui-icon>
      <div class="title"><span>본문 검색</span></div>
    </div>
    <div class="ol">
      <div class="li">
        <div class="number">1.</div>
        <div class="text">원하는 키워드로 본문을 검색합니다.</div>
      </div>
      <div class="li">
        <div class="number">2.</div>
        <div class="text">검색어가 포함된 페이지로 이동할 수 있습니다.</div>
      </div>
    </div>
  </div>
  <!-- 읽기 모드 변경 -->
  <div class="page reading-mode" *ngSwitchCase="_Page.ReadingMode">
    <div class="page-header">
      <sui-icon style="font-size: 30px" name="뷰어 그룹 변경"></sui-icon>
      <div class="title"><span>읽기 모드 변경</span></div>
    </div>
    <div class="ol">
      <div class="li reading-mode">
        <div class="number">1.</div>
        <div class="text">
          북이오에서 함께읽기 중인 책은 '그룹책', 혼자읽기 하는 책은
          '나의책'으로 구분합니다.
        </div>
      </div>
      <div class="li reading-mode">
        <div class="number">2.</div>
        <div class="text">
          열람 중 '함께읽기 <--> 혼자읽기'로 읽기 모드를 바꾸고 싶다면 화면
          상단(PC) 혹은 좌측 하단(모바일) 메뉴에서
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="102"
            height="30"
            viewBox="0 0 102 30"
            fill="none"
          >
            <rect
              width="101.053"
              height="29.9999"
              rx="14.9999"
              fill="#282828"
            />
            <path
              d="M9.625 6.00007L9.625 23.25L30.3769 23.25L30.3769 6.00007L9.625 6.00007Z"
              fill="#282828"
            />
            <path
              d="M16.1642 16.4609L10.7168 11.1781L12.0916 10.1935L15.2563 13.2625L15.2563 8.23847C15.2563 7.4766 15.9999 6.8441 16.9164 6.83691L17.0721 6.83691L17.0721 13.2625L20.2367 10.1935L21.6115 11.1781L16.1642 16.4609Z"
              fill="white"
            />
            <path
              d="M27.6059 19.0497L24.4412 15.9807L24.4412 21.0047C24.4412 21.7666 23.6976 22.3991 22.7811 22.4062L22.6254 22.4062L22.6254 15.9807L19.4607 19.0497L18.0859 18.065L23.5333 12.7822L28.9807 18.065L27.6059 19.0497Z"
              fill="white"
            />
            <path
              d="M46.0287 11.2656V12.2969C46.0287 13.543 46.0287 14.8911 45.6743 16.9482L44.6323 16.8516C45.019 14.9233 45.019 13.5107 45.019 12.2969V12.1035H39.3471V11.2656H46.0287ZM38.4018 18.5488V17.7002H47.1782V18.5488H38.4018ZM56.7065 15.0146V15.8311H52.7963V16.916H51.7866V15.8311H47.8979V15.0146H56.7065ZM49.0043 11.2549V10.4707H55.6V12.7588H50.0356V13.5645H55.7934V14.3379H49.0258V12.0176H54.5795V11.2549H49.0043ZM49.0473 19.7949V16.3896H50.0571V17.3672H54.5903V16.3896H55.6V19.7949H49.0473ZM50.0571 19H54.5903V18.1406H50.0571V19ZM60.3266 12.4043C60.3266 13.4893 61.0141 14.5474 62.2387 14.9824L61.7553 15.7559C60.8476 15.4067 60.2138 14.7461 59.8701 13.9404C59.5317 14.8159 58.8871 15.5356 57.9526 15.917L57.4692 15.165C58.6884 14.6709 59.3544 13.5698 59.3598 12.4043V12.3184H57.684V11.502H59.3598V10.3955H60.3266V11.502H61.9809V12.3184H60.3266V12.4043ZM59.0805 17.4961V16.6689H65.6225V19.9131H64.6127V17.4961H59.0805ZM62.5825 16.1426V10.46H63.56V12.8125H64.6557V10.2988H65.6225V16.1855H64.6557V13.6504H63.56V16.1426H62.5825ZM78.4164 17.8721V18.7207H69.6078V17.8721H73.4858V15.8955H70.6176V10.9434H71.6381V12.5977H76.3647V10.9434H77.3744V15.8955H74.4955V17.8721H78.4164ZM71.6381 15.0684H76.3647V13.4248H71.6381V15.0684ZM87.1176 10.2881V19.9131H86.0864V10.2881H87.1176ZM79.2114 17.335C81.768 16.1157 83.0195 14.3809 83.2182 12.1357H79.6733V11.3193H84.2494C84.2494 14.1392 83.0517 16.5776 79.7485 18.1621L79.2114 17.335Z"
              fill="white"
            />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="102"
            height="30"
            viewBox="0 0 102 30"
            fill="none"
          >
            <rect
              width="101.053"
              height="29.9999"
              rx="14.9999"
              fill="#282828"
            />
            <path
              d="M9.625 6.00007L9.625 23.25L30.3769 23.25L30.3769 6.00007L9.625 6.00007Z"
              fill="#282828"
            />
            <path
              d="M16.1642 16.4609L10.7168 11.1781L12.0916 10.1935L15.2563 13.2625L15.2563 8.23847C15.2563 7.4766 15.9999 6.8441 16.9164 6.83691L17.0721 6.83691L17.0721 13.2625L20.2367 10.1935L21.6115 11.1781L16.1642 16.4609Z"
              fill="white"
            />
            <path
              d="M27.6059 19.0497L24.4412 15.9807L24.4412 21.0047C24.4412 21.7666 23.6976 22.3991 22.7811 22.4062L22.6254 22.4062L22.6254 15.9807L19.4607 19.0497L18.0859 18.065L23.5333 12.7822L28.9807 18.065L27.6059 19.0497Z"
              fill="white"
            />
            <path
              d="M47.393 14.0693V14.9072H45.8998V19.9023H44.8793V10.2881H45.8998V14.0693H47.393ZM38.767 17.4854V11.2227H39.7768V16.6367C41.1196 16.6313 42.5214 16.5186 44.0522 16.207L44.1703 17.0664C42.5214 17.394 41.0068 17.4907 39.5619 17.4854H38.767ZM51.0453 10.9756C52.5654 10.9702 53.6611 11.9102 53.6664 13.2637C53.6611 14.6172 52.5654 15.5571 51.0453 15.5625C49.5307 15.5571 48.4189 14.6172 48.4243 13.2637C48.4189 11.9102 49.5307 10.9702 51.0453 10.9756ZM47.9623 17.0127C49.7133 17.0127 52.141 16.9966 54.2465 16.6904L54.3217 17.4316C52.1464 17.8506 49.81 17.8613 48.0912 17.8613L47.9623 17.0127ZM49.434 13.2637C49.4233 14.1177 50.1108 14.6709 51.0453 14.6709C51.9799 14.6709 52.6674 14.1177 52.6674 13.2637C52.6674 12.4204 51.9799 11.8564 51.0453 11.8564C50.1108 11.8564 49.4233 12.4204 49.434 13.2637ZM54.8481 19.9346V10.2881H55.8686V19.9346H54.8481ZM60.3266 12.4043C60.3266 13.4893 61.0141 14.5474 62.2387 14.9824L61.7553 15.7559C60.8476 15.4067 60.2138 14.7461 59.8701 13.9404C59.5317 14.8159 58.8871 15.5356 57.9526 15.917L57.4692 15.165C58.6884 14.6709 59.3544 13.5698 59.3598 12.4043V12.3184H57.684V11.502H59.3598V10.3955H60.3266V11.502H61.9809V12.3184H60.3266V12.4043ZM59.0805 17.4961V16.6689H65.6225V19.9131H64.6127V17.4961H59.0805ZM62.5825 16.1426V10.46H63.56V12.8125H64.6557V10.2988H65.6225V16.1855H64.6557V13.6504H63.56V16.1426H62.5825ZM78.4164 17.8721V18.7207H69.6078V17.8721H73.4858V15.8955H70.6176V10.9434H71.6381V12.5977H76.3647V10.9434H77.3744V15.8955H74.4955V17.8721H78.4164ZM71.6381 15.0684H76.3647V13.4248H71.6381V15.0684ZM87.1176 10.2881V19.9131H86.0864V10.2881H87.1176ZM79.2114 17.335C81.768 16.1157 83.0195 14.3809 83.2182 12.1357H79.6733V11.3193H84.2494C84.2494 14.1392 83.0517 16.5776 79.7485 18.1621L79.2114 17.335Z"
              fill="white"
            />
          </svg>
          버튼을 선택하세요.
        </div>
      </div>
      <div class="li reading-mode">
        <div class="number">3.</div>
        <div class="text">
          그룹책으로 함께읽기 중이었다면 '나의책 보기' 버튼으로, 나의책으로
          혼자읽기 중이었다면 '그룹책 보기' 버튼으로 읽기 모드를 변경할 수
          있습니다.
        </div>
      </div>
    </div>
  </div>
  <!-- 하이라이트 -->
  <div class="page highlight" *ngSwitchCase="_Page.Highlight">
    <div class="page-header">
      <sui-icon style="font-size: 30px" name="하이라이트"></sui-icon>
      <div class="title"><span>하이라이트</span></div>
    </div>
    <div class="ol">
      <div class="li">
        <div class="number">1.</div>
        <div class="text">
          본문을 드래그하면 나타나는 툴바에서 하이라이트
          <br class="desktop" />컬러 중 하나를 선택하세요. 드래그한 부분이
          선택한 <br class="desktop" />컬러로 하이라이트됩니다.
        </div>
      </div>
      <div class="li">
        <div class="number">2.</div>
        <div class="text">
          미리 등록된 옵션 외의 컬러로 하이라이트하고 싶다면
          <br class="desktop" />
          컬러 더보기 버튼
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="20"
              width="20"
              height="20"
              rx="10"
              transform="rotate(90 20 0)"
              fill="#282828"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M9.5625 10.4375V13.5H10.4375V10.4375H13.5V9.5625H10.4375L10.4375 6.5H9.5625V9.5625H6.5V10.4375H9.5625Z"
              fill="white"
            />
            <path
              d="M7.96281 8.15C8.17281 7.77 8.45781 7.47 8.82281 7.255C9.18281 7.04 9.59781 6.93 10.0678 6.93C10.5378 6.93 10.9278 7.035 11.2728 7.245C11.6128 7.455 11.8828 7.75 12.0728 8.13C12.2628 8.51 12.3578 8.945 12.3628 9.44H13.2928V6.14H12.3078V7.255C12.2878 7.22 12.2678 7.185 12.2428 7.15C11.9928 6.79 11.6678 6.505 11.2728 6.305C10.8728 6.105 10.4228 6 9.91281 6C9.29281 6 8.73281 6.155 8.23781 6.46C7.73781 6.765 7.34781 7.18 7.06281 7.7C6.77781 8.215 6.63781 8.8 6.63281 9.445H7.64781C7.64781 8.96 7.75281 8.53 7.96281 8.15Z"
              fill="white"
              fill-opacity="0.3"
            />
            <path
              d="M13.2925 9.44531V12.7603H12.3075V11.6403C12.2875 11.6753 12.2675 11.7153 12.2425 11.7453C11.9925 12.1103 11.6675 12.3953 11.2725 12.5953C10.8725 12.7953 10.4275 12.9003 9.9275 12.9003C9.2975 12.9003 8.7375 12.7503 8.2375 12.4403C7.7375 12.1353 7.3475 11.7253 7.0625 11.2103C6.7775 10.6953 6.6325 10.1103 6.6325 9.46531C6.6325 9.46031 6.6325 9.45031 6.6325 9.44531H5.3125V14.0003H14.6775V9.44531H13.2875H13.2925Z"
              fill="white"
              fill-opacity="0.3"
            />
            <path
              d="M7.64844 9.45031C7.64844 9.94031 7.75344 10.3703 7.96344 10.7453C8.17344 11.1203 8.46344 11.4153 8.82844 11.6303C9.19344 11.8453 9.61344 11.9553 10.0834 11.9553C10.7684 11.9553 11.3184 11.7253 11.7384 11.2653C12.1584 10.8053 12.3634 10.2003 12.3634 9.45031C12.3634 9.45031 12.3634 9.45031 12.3634 9.44531H7.64844C7.64844 9.44531 7.64844 9.44531 7.64844 9.45031Z"
              fill="white"
              fill-opacity="0.3"
            />
          </svg>
          을 누르고 원하는 컬러를 <br class="desktop" />선택하세요.
        </div>
      </div>
    </div>
  </div>
  <!-- 메모 -->
  <div class="page" *ngSwitchCase="_Page.Memo">
    <div class="page-header">
      <sui-icon style="font-size: 30px" name="메모" type="solid"></sui-icon>
      <div class="title"><span>메모</span></div>
    </div>
    <div class="ol">
      <div class="li">
        <div class="number">1.</div>
        <div class="text">
          본문을 드래그하면 나타나는 툴바에서 메모 버튼<sui-icon
            class="context-menu-icon"
            name="메모"
            type="solid"
          ></sui-icon
          >을 누릅니다.
        </div>
      </div>
      <div class="li">
        <div class="number">2.</div>
        <div class="text">
          '메모 작성' 팝업에 원하는 내용을 입력하고 저장하세요.
        </div>
      </div>
    </div>
  </div>
  <!-- 복사 -->
  <div class="page" *ngSwitchCase="_Page.Copy">
    <div class="page-header">
      <sui-icon style="font-size: 30px" name="복사" type="solid"></sui-icon>
      <div class="title"><span>복사/공유</span></div>
    </div>
    <div class="ol">
      <div class="li">
        <div class="number">1.</div>
        <div class="text">
          본문을 드래그하면 나타나는 툴바에서 ‘복사/공유’ 버튼을 누르면 드래그한
          부분이 출처(책 제목)와 함께 복사됩니다.
        </div>
      </div>
      <div class="li">
        <div class="number">2.</div>
        <div class="text">본문은 최대 500자까지만 복사할 수 있습니다.</div>
      </div>
      <div class="li">
        <div class="number">3.</div>
        <div class="text">
          복사한 텍스트의 딥링크도 함께 제공되어 원하는 곳에 쉽게 공유할 수
          있습니다. 링크를 클릭하면 뷰어가 열리며 선택한 문장이 하이라이트
          표시되어 있습니다. 공유받은 사람은 해당 본문이 포함된 페이지 외 책의
          다른 부분은 열람할 수 없습니다.
        </div>
      </div>
    </div>
  </div>
  <!-- 본문 공유 -->
  <div class="page" *ngSwitchCase="_Page.Share">
    <div class="page-subheader mobile">
      2자부터 500자까지, 본문의 특정 부분에 링크를 생성할 수 있는 기능입니다.
    </div>
    <div class="page-header">
      <sui-icon style="font-size: 30px" name="공유" type="solid"></sui-icon>
      <div class="title"><span>본문 공유</span></div>
      <div class="subtitle desktop">
        2자부터 500자까지, 본문의 특정 부분에<br class="desktop" />링크를 생성할
        수 있는 기능입니다.
      </div>
    </div>
    <div class="ol">
      <div class="li">
        <div class="number">1.</div>
        <div class="text">본문을 드래그합니다.</div>
      </div>
      <div class="li">
        <div class="number">2.</div>
        <div class="text">
          툴바에서 본문 공유 버튼<sui-icon
            name="공유"
            type="solid"
            class="context-menu-icon"
          ></sui-icon
          >을 누르면 드래그한 부분에 대한 링크가 생성됩니다.
        </div>
      </div>
      <div class="li">
        <div class="number">3.</div>
        <div class="text">링크를 원하는 곳에 공유합니다.</div>
      </div>
      <div class="li">
        <div class="number">4.</div>
        <div class="text">
          공유받은 사람이 링크를 누르면 이 전자책의 드래그한 부분으로
          <br class="desktop" />
          이동하며, 드래그한 부분이 속한 페이지를 볼 수 있습니다.
        </div>
      </div>
    </div>
  </div>
  <!-- 본문 공유 -->
  <div class="page my-record" *ngSwitchCase="_Page.Annotations">
    <div class="page-header">
      <div class="title small"><span>내 기록 보기</span></div>
    </div>
    <div class="columns my-record-guide">
      <div class="column">
        <div class="ol">
          <div class="list-title">그룹책</div>
          <div class="li">
            <div class="number">1.</div>
            <div class="text">
              그룹책에 내가 친 밑줄은 노란색으로, 댓글은 하늘색 점으로
              표시됩니다.
            </div>
          </div>
          <div class="li">
            <div class="number">2.</div>
            <div class="text">
              내가 한 밑줄과 댓글을 모아 보고 싶다면 상단 메뉴에서 ‘전체 댓글'
              버튼 선택 후 오른쪽 사이드바에서 ‘내 기록' 탭을 선택하세요.
            </div>
          </div>
          <div class="li">
            <div class="number">3.</div>
            <div class="text">
              처음 뷰어 진입시 사이드바는 열려 있습니다. 원하는 경우 X 버튼으로
              사이드바를 닫고 본문에 집중하여 책을 읽을 수 있습니다.
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="ol">
          <div class="list-title">나의책</div>

          <div class="li">
            <div class="number">1.</div>
            <div class="text">
              나의책에는 내가 남긴 하이라이트와 메모(노란색 아이콘)가
              표시됩니다.
            </div>
          </div>
          <div class="li">
            <div class="number">2.</div>
            <div class="text">
              하이라이트와 메모를 모아 보고 싶다면 상단 메뉴에서 ‘내 기록'
              버튼을 선택하세요.
            </div>
          </div>
          <div class="li">
            <div class="number">3.</div>
            <div class="text">
              나의책에서는 북마크한 페이지도 모아 볼 수 있습니다.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- 코멘터리 보기 -->
  <!-- <div class="page" *ngSwitchCase="_Page.Commentary">
    <div class="page-header">
      <div class="title"><span>코멘터리 보기</span></div>
    </div>
    <div class="ol">
      <div class="li">
        <div class="number">1.</div>
        <div class="text">
          코멘터리는 코멘터리북에서 코멘테이터가 남긴 독서기록을 의미합니다.
          코멘터리는 ‘나의책’에서 확인할 수 있습니다. 
        </div>
      </div>
      <div class="li">
        <div class="number">2.</div>
        <div class="text">
          코멘테이터가 남긴 하이라이트는 하늘색 밑줄로, 메모는 하늘색 아이콘으로
          표시됩니다. 
        </div>
      </div>
      <div class="li">
        <div class="number">3.</div>
        <div class="text">
          코멘테이터의 하이라이트와 메모를 모아 보고 싶다면 상단 메뉴에서 ‘내
          기록’ 버튼 선택 후 오른쪽 사이드바에서 ‘코멘터리’ 탭을 선택하세요. 
        </div>
      </div>
    </div>
  </div> -->
  <!-- 멤버 기록 보기 -->
  <div class="page member-record" *ngSwitchCase="_Page.GroupShared">
    <div class="page-header">
      <div class="title">
        <span>멤버 기록 보기</span>
      </div>
    </div>
    <div class="columns member-record-guide">
      <div class="column">
        <div class="ol member-record">
          <div class="li">
            <div class="number">1.</div>
            <div class="text">
              그룹책에 멤버들이 친 밑줄은 초록색으로, 댓글은 하늘색 점으로
              표시됩니다.
            </div>
          </div>
          <div class="li">
            <div class="number">2.</div>
            <div class="text">
              밑줄을 그은 사람이 많은 문장일수록 초록색 밑줄의 색이 짙어집니다.
            </div>
          </div>
          <div class="li">
            <div class="number">3.</div>
            <div class="text">
              특정 멤버의 기록을 모아 보고 싶다면 상단 메뉴에서 ‘전체 댓글' 버튼
              선택 후 오른쪽 사이드바에서 ‘멤버 기록' 탭을 선택하세요.
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="ol member-record">
          <div class="li">
            <div class="number">4.</div>
            <div class="text">
              함께읽기 중인 멤버의 목록을 확인하고, 원하는 멤버를 선택하세요.
            </div>
          </div>
          <div class="li">
            <div class="number">5.</div>
            <div class="text">
              선택한 멤버가 그 그룹책에 남긴 밑줄과 댓글을 확인할 수 있습니다.
            </div>
          </div>
          <div class="li">
            <div class="number">6.</div>
            <div class="text">
              ‘그룹책 멤버 선택하기' 버튼으로 다른 멤버의 기록도 확인해 보세요.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #listItem let-item="item">
  <div class="list-item" (click)="_onPageListItemClick(item.page)">
    <div class="item-icon">
      <sui-icon
        [name]="item.iconName"
        [style.font-size.px]="item.iconSize"
        [type]="item.iconType"
      ></sui-icon>
    </div>
    <div class="item-title">{{ item.title }}</div>
    <sui-icon class="item-arrow" name="화살표_오른쪽"></sui-icon>
  </div>
</ng-template>
